export const CHART_COLORS = [
  '#0086C9',
  '#0E9384',
  '#CA8504',
  '#4F7A21',
  '#7839EE',
  '#F63D68',
  '#D444F1',
  '#FF4405'
];

export const CHART_ORDINAL_RAMP = ['#36BFFA', '#0BA5EC', '#0086C9', '#026AA2'];

export const CHART_INK = {
  label: '#717680',
  legendLabel: '#535862',
  grid: '#E9EAEB',
  value: '#181D27',
  caption: '#717680',
  surface: '#FFFFFF'
};

export const CHART_HOVER_MARKER_SIZE = 6;

export const CHART_SHADOW = {
  ring: { enabled: true, color: 'rgba(10, 18, 57, 0.16)', xOffset: 0, yOffset: 5, blur: 12 },
  area: { enabled: true, color: 'rgba(0, 134, 201, 0.14)', xOffset: 0, yOffset: 6, blur: 14 }
};

export const CHART_DANGER = '#D92D20';
export const CHART_SUCCESS = '#16B364';

export const CHART_BILLING_COLORS = {
  insurancePayments: '#7CD4FD',
  patientPayments: '#0BA5EC',
  technologyFee: '#0086C9',
  adjustments: '#026AA2',
  accountReceivable: '#0B4A6F',
  totalReceived: '#0E9384',
  totalCharges: '#414651'
};

export const CHART_STATUS_COLORS = {
  accepted: CHART_SUCCESS,
  active: CHART_SUCCESS,
  acknowledged: '#0E9384',
  archived: '#717680',
  authorization: CHART_COLORS[5],
  coding: CHART_COLORS[4],
  eligibility: CHART_COLORS[2],
  other: '#717680',
  awaiting_cosign: '#DC6803',
  billing: '#026AA2',
  canceled: CHART_DANGER,
  cancelled: CHART_DANGER,
  'check-in': '#36BFFA',
  clinical: '#0086C9',
  complete: CHART_SUCCESS,
  completed: '#065986',
  deleted: CHART_DANGER,
  denied: '#B42318',
  draft: '#F79009',
  financial: '#0BA5EC',
  finalized: CHART_SUCCESS,
  high: CHART_DANGER,
  inactive: CHART_DANGER,
  low: '#717680',
  medium: '#DC6803',
  no_payment: '#A4A7AE',
  no_show: '#535862',
  not_started: '#F04438',
  paid: '#087443',
  pending: '#DC6803',
  ready: '#0086C9',
  rejected: '#912018',
  unpaid: '#F79009'
};

export const CHART_FONT = "'Plus Jakarta Sans', sans-serif";
